export default __webpack_public_path__ + "static/media/timecardApproval.071afa5e.svg";